import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import getters from './getters'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((module, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  module[moduleName] = value.default
  return module
}, {})

export default new Vuex.Store({
  modules,
  getters,
  // FIXME: 写一个插件 保证某些state能进storage 某些state不进storage 譬如loginState就不能进storage  (!!!storage中的信息要加密)
  plugins: [createPersistedState({
    storage: window.localStorage
  })]
})
